module.exports = vendor;


//////////////////
// WEBPACK FOOTER
// external "vendor"
// module id = dll-reference vendor
// module chunks = 0